<script setup>
import { isEmpty } from "lodash";
const props = defineProps({
  title: {type: String, default: undefined},
  message: {type: String, default: ''}
})
</script>
<script>
export default {
  name: "DpLoading"
};
</script>

<template>
  <div class="dp-loading">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 55 55" style="enable-background:new 0 0 55 55;" xml:space="preserve">
      <polygon class="top-left" points="25.2,18.8 25.2,2.5 8.9,2.5 2.5,8.9 2.5,25.2 18.8,25.2"/>
      <polygon class="top-right" points="25.2,18.8 25.2,2.5 8.9,2.5 2.5,8.9 2.5,25.2 18.8,25.2"/>
      <polygon class="bottom-right" points="25.2,18.8 25.2,2.5 8.9,2.5 2.5,8.9 2.5,25.2 18.8,25.2"/>
      <polygon class="bottom-left" points="25.2,18.8 25.2,2.5 8.9,2.5 2.5,8.9 2.5,25.2 18.8,25.2"/>
    </svg>
    <div v-if="!isEmpty(props.title)">
      <h4><slot name="title">{{ props.title }}</slot></h4>
    </div>
    <div><slot>{{ props.message }}</slot></div>
  </div>
</template>

<style lang="scss">

.dp-loading {
  $sizeIcon: 50px;
  $sizePolygon: 22.725px;
  $sizePolygonMid: $sizePolygon / 2;
  $sizeViewBox: 55px;
  $sizeViewBoxMid: $sizeViewBox / 2;
  $animationParameter: 2.5s infinite cubic-bezier(0.645,0.045,0.355,1);

  margin: 1rem 0;
  padding: 1em;
  text-align: center;
  border-radius: 8px;

  svg {
    margin: 1rem 0;
    height: $sizeIcon;
    width: $sizeIcon;

    polygon {
      fill: var(--application-color);
    }

    .top-left {
      animation: dp-loading-icon-keyframes__top-left $animationParameter;
    }

    .top-right {
      animation: dp-loading-icon-keyframes__top-right $animationParameter;
    }

    .bottom-left {
      animation: dp-loading-icon-keyframes__bottom-left $animationParameter;
    }

    .bottom-right {
      animation: dp-loading-icon-keyframes__bottom-right $animationParameter;
    }
  }

  @keyframes dp-loading-icon-keyframes__bottom-left {
    17%, 65% {
      transform: translate(0, $sizeViewBoxMid) scale3d(1,1,1);
    }
    0%, 100% {
      transform: translate($sizePolygonMid, $sizeViewBoxMid + $sizePolygonMid) scale3d(0,0,0);
    }
  }

  @keyframes dp-loading-icon-keyframes__top-left {
    28%, 76% {
      transform: translate(0, 0) scale3d(1,1,1);
    }
    0%, 100% {
      transform: translate($sizePolygonMid, $sizePolygonMid) scale3d(0,0,0);
    }
  }

  @keyframes dp-loading-icon-keyframes__bottom-right {
    35%, 83% {
      transform: translate($sizeViewBoxMid, $sizeViewBoxMid) scale3d(1,1,1);
    }
    0%, 100% {
      transform: translate($sizeViewBoxMid + $sizePolygonMid, $sizeViewBoxMid + $sizePolygonMid) scale3d(0,0,0);
    }
  }

  @keyframes dp-loading-icon-keyframes__top-right {
    39%, 87% {
      transform: translate($sizeViewBoxMid, 0) scale3d(1,1,1);
    }
    0%, 100% {
      transform: translate($sizeViewBoxMid + $sizePolygonMid, $sizePolygonMid) scale3d(0,0,0);
    }
  }
}

</style>
